import { Card, CardContent } from "@mui/material";
import { Box } from "@mui/system";
import {  useState } from "react";
import { useForm } from "react-hook-form";
import { ISurveyTemplateQuestionData } from "shared/components/SurveyTemplate";
import SurveyTemplate from "./SurveyTemplate";

type Props = {
  previewModalData: ISurveyTemplateQuestionData;
};

export enum EQuestionPreviewType {
  MOBILE = 1,
  DESKTOP,
}

const QuestionPreview = ({ previewModalData }: Props) => {
  const [type] = useState(EQuestionPreviewType.MOBILE);

  const methods = useForm({
    defaultValues: {
      answerIDs: [],
      comment: "",
      singleChoice: "",
      contact: "",
      rate: 0,
      contactConfig: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      },
    },
  });

  // const chooseType = (
  //   event: MouseEvent<HTMLElement>,
  //   newAlignment: EQuestionPreviewType | null
  // ) => {
  //   if (newAlignment !== null) {
  //     setType(newAlignment);
  //   }
  // };

  return (
    <Box
      sx={
        type === EQuestionPreviewType.MOBILE
          ? { justifyContent: "center", display: "flex", background: "white" }
          : null
      }
    >
      <Box
        sx={
          type === EQuestionPreviewType.MOBILE
            ? { width: "360px" }
            : { width: "100vw" }
        }
      >
        <Box
          display="flex"
          justifyContent={"center"}
          sx={{
            backgroundImage: `url(${require("assets/images/bg.png")})`,
            height: "94.4vh",
            backgroundSize: "cover",
          }}
        >
          <Box p={2}>
            <Box textAlign="center" pb={1}></Box>
            <Card
              sx={{
                height: { xs: "80vh" },
                backgroundColor: "rgb(255 255 255 / 97%)",
                overflowY: "scroll",
              }}
            >
              <CardContent
                sx={{
                  py: { xs: "10px", lg: "16px" },
                  px: 0,
                  ":last-child": {
                    pb: 0,
                  },
                }}
              >
                <Box
                  sx={
                    type === EQuestionPreviewType.MOBILE
                      ? {}
                      : {
                          width: {
                            xs: "85vw",
                            sm: "80vw",
                            md: "60vw",
                            lg: "50vw",
                          },
                        }
                  }
                >
                  <SurveyTemplate
                    methods={methods}
                    viewType={type}
                    questionData={previewModalData}
                  />
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuestionPreview;
